export default {
    init() {
        Chart.register(ChartDataLabels);
        this.render();
    },

    render() {
        $("[data-chart_config]").each(function () {
            const element = $(this);
            const config = element.data("chart_config");
            const chartContainer = element.closest("[data-chart-rows]");
            const rowCount = Number(chartContainer.data("chart-rows"));

            if (rowCount > 0) {
                const rowHeight = window.matchMedia("(max-width: 575px)").matches ? 42 : 36;
                chartContainer.height(Math.max(320, rowCount * rowHeight));
            }

            config.options.plugins.datalabels.formatter = function (value) {
                return value.toFixed(2) + " zł";
            };
            new Chart(element[0], config);
        });
    },
};
